'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getRequiredState = function getRequiredState(_ref) {
  var required = _ref.required,
      value = _ref.value;
  return !required || value !== undefined && value !== null && (typeof value !== 'string' || value.trim() !== '');
};

var getPatternsState = function getPatternsState(_ref2) {
  var patterns = _ref2.patterns,
      value = _ref2.value;
  return Array.isArray(patterns) ? patterns.filter(function (pattern) {
    return pattern instanceof RegExp && !pattern.test(value) || typeof pattern === 'function' && !pattern(value);
  }) : [];
};

var Validation = function (_Component) {
  _inherits(Validation, _Component);

  function Validation(props) {
    _classCallCheck(this, Validation);

    var _this = _possibleConstructorReturn(this, (Validation.__proto__ || Object.getPrototypeOf(Validation)).call(this, props));

    _this.getUpdatedValidation = _this.getUpdatedValidation.bind(_this);
    _this.getValidity = _this.getValidity.bind(_this);
    _this.checkPatternMet = _this.checkPatternMet.bind(_this);
    _this.checkRequiredMet = _this.checkRequiredMet.bind(_this);
    _this.registerValidate = _this.registerValidate.bind(_this);
    _this.unregisterValidate = _this.unregisterValidate.bind(_this);
    _this.state = { validators: {} };
    return _this;
  }

  _createClass(Validation, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getValidity: this.getValidity,
        checkPatternMet: this.checkPatternMet,
        checkRequiredMet: this.checkRequiredMet,
        registerValidate: this.registerValidate,
        unregisterValidate: this.unregisterValidate
      };
    }
  }, {
    key: 'registerValidate',
    value: function registerValidate(validationState, id) {
      var _this2 = this;

      if (!this.state.validators[id]) {
        this.setState(function (_ref3) {
          var validators = _ref3.validators;
          return {
            invalidationId: _this2.getFirstInvalidId(),
            validators: _extends({}, validators, _defineProperty({}, id, validationState))
          };
        });
      }
    }
  }, {
    key: 'unregisterValidate',
    value: function unregisterValidate(_, id) {
      var _this3 = this;

      if (this.state.validators[id]) {
        this.setState(function (_ref4) {
          var validators = _ref4.validators;
          return {
            invalidationId: _this3.getFirstInvalidId(),
            validators: (0, _lodash2.default)(validators, id)
          };
        });
      }
    }
  }, {
    key: 'getValidity',
    value: function getValidity(id) {
      var _state = this.state,
          validated = _state.validated,
          invalidationId = _state.invalidationId;


      if (!validated) {
        return true;
      }

      if (!this.getOverallRequiredValidity()) {
        return this.checkRequiredMet(id);
      }

      if (id !== invalidationId) {
        return true;
      }

      return !this.getInvalidations(id).length;
    }
  }, {
    key: 'getErrorMessage',
    value: function getErrorMessage(id) {
      if (!this.getOverallRequiredValidity()) {
        return this.props.requiredError;
      }

      if (id) {
        var _state$validators$id = this.state.validators[id](),
            error = _state$validators$id.error;

        if (error) return error(this.getInvalidations(id));
      }

      return null;
    }
  }, {
    key: 'getInvalidations',
    value: function getInvalidations(id) {
      return this.state.validators[id] ? getPatternsState(this.state.validators[id]()) : [];
    }
  }, {
    key: 'getFirstInvalidId',
    value: function getFirstInvalidId() {
      var getOverallRequiredValidity = this.getOverallRequiredValidity();
      if (!getOverallRequiredValidity) return;

      var invalidations = this.getAllInvalidations();
      var firstInvalidValidator = Object.keys(invalidations).find(function (id) {
        return invalidations[id].length > 0;
      });
      return firstInvalidValidator ? firstInvalidValidator : '';
    }
  }, {
    key: 'getAllInvalidations',
    value: function getAllInvalidations() {
      var _this4 = this;

      return Object.keys(this.state.validators).reduce(function (left, nextId) {
        return _extends({}, left, _defineProperty({}, nextId, _this4.getInvalidations(nextId)));
      }, {});
    }
  }, {
    key: 'getOverallRequiredValidity',
    value: function getOverallRequiredValidity() {
      var _this5 = this;

      return Object.keys(this.state.validators).every(function (id) {
        return _this5.checkRequiredMet(id);
      });
    }
  }, {
    key: 'checkPatternMet',
    value: function checkPatternMet(id, metPattern) {
      return this.getInvalidations(id).indexOf(metPattern) === -1;
    }
  }, {
    key: 'checkRequiredMet',
    value: function checkRequiredMet(key) {
      return this.state.validators[key] ? getRequiredState(this.state.validators[key]()) : true;
    }
  }, {
    key: 'getUpdatedValidation',
    value: function getUpdatedValidation() {
      var invalidationId = this.getFirstInvalidId();
      var error = this.getErrorMessage(invalidationId);

      this.setState({ invalidationId: invalidationId, validated: true });

      return error;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.getUpdatedValidation);
    }
  }]);

  return Validation;
}(_react.Component);

Validation.propTypes = {
  /**
   * Function that returns React.node type and is provided with information
   * of the overall validity of all the child Validate's state.
   *
   * @param {function} getUpdatedValidation Returns a boolean of the overall
   * validity.
   * @param {string} error Error message, either for the overall required
   * invalidation, or provided by an individual Validate component.
   */
  children: _propTypes2.default.func.isRequired,
  /** Error to output when required fields have not been met */
  requiredError: _propTypes2.default.string
};
Validation.childContextTypes = {
  getValidity: _propTypes2.default.func.isRequired,
  checkPatternMet: _propTypes2.default.func.isRequired,
  checkRequiredMet: _propTypes2.default.func.isRequired,
  registerValidate: _propTypes2.default.func.isRequired,
  unregisterValidate: _propTypes2.default.func.isRequired
};
exports.default = Validation;